<input
  pInputText
  class="pp-input"
  [type]="type"
  [placeholder]="placeholder"
  [attr.maxlength]="maxlength"
  [disabled]="disabled"
  [ngModel]="value"
  (ngModelChange)="onInput($event)"
  (blur)="onBlur()" />
